import { Component, Input, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap'; // Import NgbTooltip

@Component({
  selector: 'app-time-zone-hover',
  templateUrl: './time-zone-hover.component.html',
  styleUrls: ['./time-zone-hover.component.css'],
})
export class TimeZoneHoverComponent {

  @Input() utcTime: string = new Date().toISOString();
  localTime: string ='';

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter')
  onMouseEnter(): void {
    this.convertToLocalTime();
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.localTime = this.utcTime;
  }

  private convertToLocalTime(): void {
    const date = new Date(this.utcTime);
    const localDateTime = date.toLocaleString();
    this.localTime = localDateTime;
  }

  getTimeZone(utcTime: string): string {
    const date = new Date(utcTime);
    const timeZone = date.toLocaleTimeString(undefined, { timeZoneName: 'short' });
    return timeZone;
  }
}
